import type { AgentId, AgentStatus, ProposalKind } from '../../api/agentSchemas';
import type { OrbForm } from './orb/orbForms';

/**
 * One dot, four planets: every agent is the same orange sphere drawn the way
 * its planet looks. Júpiter wears its bands of latitude, Venus its dusting of
 * cloud, Mercurio a crisp net, Marte a ring of dots circling it like its
 * moons. The big orb takes the form of whoever is talking.
 */
export const AGENT_FORM: Readonly<Record<AgentId, OrbForm>> = {
  direccion: 'rings',
  marketing: 'stipple',
  finanzas: 'lattice',
  operaciones: 'orbit',
};

/** Seeds keep each agent's dots in the same places on every visit. */
export const AGENT_SEED: Readonly<Record<AgentId, number>> = {
  direccion: 7,
  marketing: 19,
  finanzas: 23,
  operaciones: 31,
};

/** Status as words, never color alone. */
export const STATUS_LABEL: Readonly<Record<AgentStatus, string>> = {
  available: 'Disponible',
  working: 'Midiendo el resultado',
  needs_review: 'Necesita revisión',
};

/** The `.status` tones: copper asks for the owner, green is at work, grey is free. */
export const STATUS_TONE: Readonly<Record<AgentStatus, 'due' | 'good' | 'off'>> = {
  available: 'off',
  working: 'good',
  needs_review: 'due',
};

/** What approving does, said before the owner presses it. */
export const ON_APPROVE: Readonly<Record<ProposalKind, string>> = {
  offer: 'Se crea la oferta en Ofertas, con estas fechas y este descuento. Puedes pausarla cuando quieras.',
  win_back:
    'Te preparo un enlace de WhatsApp por cliente con su nombre ya puesto. Lo envías tú desde tu teléfono; Dale no manda nada.',
  confirm_visits:
    'Te preparo un enlace de WhatsApp por cita con la hora y el servicio. Lo envías tú desde tu teléfono; Dale no manda nada.',
};
